/* eslint-disable radix */
import {
  concat, filter, findIndex, insert, merge, propEq, reject
} from 'ramda';
import {
  FAIL, SUCCESS, REQUEST, OPTIONS_SUCCESS, PUT_FAIL, PUT_REQUEST, PUT_SUCCESS, POST_SUCCESS, POST_FAIL, POST_REQUEST,
  DELETE_SUCCESS, DELETE_FAIL, DELETE_REQUEST, REQUEST_WITH_JOBS, FAIL_WITH_JOBS, SUCCESS_WITH_JOBS
} from 'src/store/actions/departmentsActions';

const initialState = {
  list: [],
  options: [],
  fetching: false,
  errors: []
};

export const getDepartmentJobs = (department, jobsOptions) => {
  if (department && department.DepartmentJobs) {
    const jobIsRelevant = (job) => department.DepartmentJobs.includes(parseInt(job.value));
    return filter(jobIsRelevant, jobsOptions);
  }
  return [];
};

const addOrReplaceInList = (department, prop, list) =>
  // concat([filter], reject(propEq(prop, filter[prop]), list)); // if it exists, then add it to the list but remove old value first.
  // eslint-disable-next-line implicit-arrow-linebreak
  insert(findIndex(propEq(prop, department[prop]), list), department, reject(propEq(prop, department[prop]), list));

const departmentToOption = ({ DepartmentId, DepartmentName }) => ({ label: DepartmentName, value: `${DepartmentId}` });

const departmentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_WITH_JOBS:
      return merge(state, { fetching: true });
    case SUCCESS_WITH_JOBS:
      return merge(state, { list: action.departments, fetching: false }); // departments data
    case FAIL_WITH_JOBS:
      return merge(state, { errors: action.err, fetching: false });
    case OPTIONS_SUCCESS:
      return merge(state, { options: action.departmentsOptions }); // departments options
    case PUT_REQUEST:
      return merge(state, { fetching: true, errors: [] });
    case PUT_SUCCESS:
      return merge(state, {
        fetching: false,
        errors: [],
        list: addOrReplaceInList(action.department, 'DepartmentId', state.list),
        options: addOrReplaceInList(departmentToOption(action.department), 'value', state.options)
      });
    case PUT_FAIL:
      return merge(state, { errors: action.err, fetching: false });
    case POST_REQUEST:
      return merge(state, { fetching: true, errors: [] });
    case POST_SUCCESS:
      return merge(state, {
        list: concat(state.list, [action.department]),
        options: concat(state.options, [departmentToOption(action.department)]),
        fetching: false,
        errors: []
      });
    case POST_FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    case DELETE_REQUEST:
      return merge(state, { fetching: true });
    case DELETE_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case DELETE_SUCCESS:
      return merge(state, {
        errors: [],
        fetching: false,
        list: reject(propEq('DepartmentId', parseInt(action.departmentId)), state.list),
        options: reject(propEq('value', `${action.departmentId}`), state.options)
      });
    default:
      return state;
  }
};

export default departmentsReducer;
